var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "audiology-kpis__teaser" }, [
    _c("img", {
      staticClass: "audiology-kpis__teaser-image",
      attrs: { src: "/images/kpis.png" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "audiology-kpis__teaser-overlay" }, [
      _c("div", { staticClass: "audiology-kpis__teaser-message" }, [
        _c("div", { staticClass: "tab__sub-header" }, [
          _vm._v("NO KPI DATA UPLOADED")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Please speak with your "),
          _c(
            "a",
            {
              staticClass: "audiology-kpis__teaser-rm-link",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.activateModal($event)
                }
              }
            },
            [_vm._v("regional manager")]
          ),
          _vm._v(" about getting this data into the system.")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }